import { IFormRegister } from 'routes/Main/type';

import Form from 'components/Form';
import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';

interface Props extends IFormRegister {
  disabled?: boolean;
  agreementInfo?: any;
}

const Signature = (props: Props) => {
  const { disabled, register, agreementInfo } = props;

  const labels = [
    { title: '실습 교과목명', variable: 'pa_subject_name' },
    { title: '날짜', variable: 'pa_date' },
    { title: '학번', variable: 'pa_student_number' },
    { title: '이름', variable: 'pa_name' },
    { title: '서명', variable: 'pa_signature' },
  ];

  return (
    <>
      <RowContainer xs={12} sx={{ userSelect: 'none' }}>
        {labels.map(({ title, variable }, _) => (
          <>
            {Array(3)
              .fill(0)
              .map(() => (
                <RowContent titleRatio={1} childrenRatio={2} />
              ))}
            {variable === 'pa_date' ? (
              <RowContent
                key={variable}
                title={title}
                titleRatio={1}
                childrenRatio={2}
              >
                <Form.MuiTextField
                  type="date"
                  disabled={disabled}
                  {...register(`${variable}`)}
                  defaultValue={agreementInfo?.[variable] || ''}
                  onPaste={e => e.preventDefault()}
                  onKeyDown={e => {
                    if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
                      e.preventDefault();
                    }
                  }}
                  onContextMenu={e => e.preventDefault()}
                />
              </RowContent>
            ) : (
              <RowContent
                key={variable}
                title={title}
                titleRatio={1}
                childrenRatio={2}
              >
                <Form.MuiTextField
                  disabled={disabled}
                  {...register(`${variable}`)}
                  defaultValue={agreementInfo?.[variable] || ''}
                  onPaste={e => e.preventDefault()}
                  onKeyDown={e => {
                    if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
                      e.preventDefault();
                    }
                  }}
                  onContextMenu={e => e.preventDefault()}
                />
              </RowContent>
            )}
          </>
        ))}
      </RowContainer>
    </>
  );
};

export default Signature;
